import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { ModalService } from '../../../core/services/modal.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { Item } from '../../../core/components/listbox/listbox.component';

@Component({
  selector: 'tt-p2-export-proc-user-groups',
  templateUrl: './p2-export-proc-user-groups.component.html',
  styleUrls: ['./p2-export-proc-user-groups.component.css']
})
export class P2ExportProcUserGroupsComponent implements OnInit {
    p2ExportProcKeyno;

    public setting?: Setting;

    public itemsListUserGroups: Item[] = [];

    public saving = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.p2ExportProcKeyno = this.stateService.getStateParams()['p2_exportproc_keyno'];
    }

    private async loadSetting() {
        if (!!this.p2ExportProcKeyno) {
            this.setting = (await this.datatask.Post(1892, { p2_exportproc_keyno: this.p2ExportProcKeyno }))[0];
        }
    }

    private async loadUserGroups() {
        if (!this.setting) return;

        this.itemsListUserGroups = await this.datatask.Post(1893, { p2_exportproc_keyno: this.setting?.p2_exportproc_keyno });
    }

    toggleChosen(item: any): void {
        item = item?.item ? item.item : item;

        if (item.item_id === '0' || item.item_id === '-1') return;

        if (item.item_is_selected === '0') {
            item.item_is_selected = '1';
        } else if (item.item_is_selected === '1') {
            item.item_is_selected = '0';
        }
    }

    public async saveChanges() {
        if (!!this.itemsListUserGroups) {
            try {
                this.saving = true;

                const selectedItems = (this.itemsListUserGroups ?? []).filter((row) => row['item_is_selected'] === '1').map((row) => ({
                    item_id: row['item_id'],
                    item_is_selected: row['item_is_selected']
                }));

                const response = (await this.datatask.Post(1894, { records: selectedItems }))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        await this.loadSetting();
        this.loadUserGroups();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    p2_exportproc_keyno: string;
    p2_exportproc_name: string;
}


//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('p2ExportProcUserGroups', {
//        templateUrl: 'views/components/views/p2ExportProcUserGroups/p2ExportProcUserGroups.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'utilityService', 'translateService', 'modalService', 'p2ExportProcUserGroupsService', function ($stateParams, stateService, utilityService, translateService, modalService, p2ExportProcUserGroupsService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let p2ExportProcKeyno = $stateParams.p2_exportproc_keyno;

//            let translations = {
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                setting: {},
//                itemsListUserGroups: [],
//                lockedSave: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATION FUNCTION

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATION FUNCTION

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadSetting() {
//                vm.model.setting = (await p2ExportProcUserGroupsService.getSetting({ p2_exportproc_keyno: p2ExportProcKeyno }))[0];
//            }

//            async function loadExportProcUserGroups() {
//                if (utilityService.validateParmsValue(vm.model.setting.p2_exportproc_keyno) !== true) return;

//                return vm.model.itemsListUserGroups = await p2ExportProcUserGroupsService.listExportProcUserGroups({ p2_exportproc_keyno: vm.model.setting.p2_exportproc_keyno });
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region TOGGLE LIST FUNCTION

//            vm.toggleChosen = function (item) {
//                item = item?.item ? item.item : item;

//                if (item.item_id === '0' || item.item_id === '-1') return;

//                if (item.item_is_selected === '0') {
//                    item.item_is_selected = '1';
//                } else if (item.item_is_selected === '1') {
//                    item.item_is_selected = '0';
//                }
//            }

//            // #endregion TOGGLE LIST FUNCTION

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                let currentData = [];
//                let selectedRows = [];
//                currentData = vm.model.itemsListUserGroups;

//                currentData.forEach((item) => {
//                    selectedRows.push({
//                        item_id: item.item_id,
//                        item_is_selected: item.item_is_selected
//                    });
//                });

//                p2ExportProcUserGroupsService.saveObj({ records: selectedRows }).then(function (response) {
//                    if (response[0].errorcode !== '0') {
//                        modalService.show({
//                            type: 'warning',
//                            title: translations.error,
//                            message: response[0].errormessage,
//                            buttons: [{
//                                label: translations.ok,
//                                cssClass: 'btn-warning',
//                                action: function (dialogItself) {
//                                    dialogItself.close();
//                                    vm.model.lockedSave = false;
//                                }
//                            }]
//                        });
//                    } else {
//                        vm.model.lockedSave = false;
//                        stateService.back();
//                    }
//                });
//            }

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                translate();
//                await loadSetting();
//                loadExportProcUserGroups();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
